import dayjs from 'dayjs'

export const datesMixin = {
  methods: {
    friendlyDate: function (date) {
      return dayjs(date).format('D MMM \'YY')
    },
    friendlyDateAndTime: function (date) {
      return dayjs(date).format('D MMM \'YY @ HH:mm')
    },
    friendlyDateFull: function (date) {
      return dayjs(date).format('D MMMM YYYY')
    }
  }
}
